import { render } from "./CompFooter.vue?vue&type=template&id=27316d73"
import script from "./CompFooter.vue?vue&type=script&lang=js"
export * from "./CompFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__